export const COPY_SUCCESS = "PASSWORD SUCCESSFULLY COPIED TO CLIPBOARD";
